import "./header.css";

const Header = () => {
   return (
      <header>
         <div className="background"></div>
      </header>
   );
};

export default Header;
